/* /pages/hyt-7pm-bp story layer (hysp-skin + hysp-chapter). Reads hbo-hero, never edits its logic.
   Built in ~/pc-hyt-sp. Every hbo hook is guarded: if one is missing the page stays plain hyt-bp. */
(function () {
  'use strict';
  var d = document, de = d.documentElement, w = window;
  if (w.__HYSP) return; w.__HYSP = true;
  var RM = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var IO = 'IntersectionObserver' in w;
  if (!RM && IO) de.classList.add('hysp-anim');

  var cfg = {};
  try { cfg = JSON.parse(d.querySelector('[data-hysp-cfg]').textContent); } catch (e) {}
  var hero = d.querySelector('[data-hbo-hero]');
  var heroCfg = {};
  try { heroCfg = JSON.parse(hero.querySelector('[data-hbo-json]').textContent); } catch (e) {}
  var tiers = heroCfg.tiers || [];

  function $all(sel, root) { return [].slice.call((root || d).querySelectorAll(sel)); }
  function playSafe(v) { try { var p = v.play(); if (p && p.catch) p.catch(function (e) { if (e && e.name === 'NotAllowedError') lockLoops(); }); } catch (e) {} }
  /* loop videos: each keeps __want (on screen = true). iOS Low Power Mode and a hot phone refuse muted loops until a tap,
     so a refused play waits for the next tap, frees every loop and restarts the ones on screen; a scroll that was not a tap re-arms it */
  var LOOPS = [], loopsLocked = false, UNLOCK_EV = ['touchend', 'click', 'keydown'];
  function loopReg(v) {
    LOOPS.push(v);
    v.addEventListener('canplay', function () { if (v.__want && v.paused) playSafe(v); });
  }
  function lockLoops() {
    if (loopsLocked) return; loopsLocked = true;
    UNLOCK_EV.forEach(function (t) { d.addEventListener(t, unlockLoops, { capture: true, passive: true }); });
  }
  function unlockLoops() {
    loopsLocked = false;
    UNLOCK_EV.forEach(function (t) { d.removeEventListener(t, unlockLoops, true); });
    LOOPS.forEach(function (v) {
      /* an autoplay change inside a tap lifts WebKit's gesture lock on that element */
      var had = v.hasAttribute('autoplay');
      v.removeAttribute('autoplay'); v.setAttribute('autoplay', '');
      if (!had) v.removeAttribute('autoplay');
      if (v.__want) playSafe(v);
    });
  }
  function barH() {
    /* the Halloween bar (#hwb, sticky on this page) replaces .hbo-cd while it runs; take whichever is showing */
    var b = [].slice.call(d.querySelectorAll('.hwb--stick, .hbo-cd--sticky')).filter(function (x) { return x.offsetHeight > 0; })[0];
    if (!b) return 0;
    var r = b.getBoundingClientRect();
    return r.top <= 1 && r.bottom > 0 ? r.bottom : 0;
  }

  /* ---------- live price in story buttons, follows the hero tier pick (as hbo-sticky does) */
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function curTier() {
    var i = 0;
    if (hero) $all('.hbo-hero__info [data-tier]', hero).forEach(function (el) {
      if (el.getAttribute('aria-checked') === 'true') i = +el.getAttribute('data-tier');
    });
    return tiers[i] || tiers[0];
  }
  function paintPrices() {
    var t = curTier(); if (!t) return;
    $all('[data-hysp-now]').forEach(function (el) { el.textContent = money(t.sub); });
    $all('[data-hysp-cmp]').forEach(function (el) { el.textContent = t.cmp > t.sub ? money(t.cmp) : ''; });
    $all('[data-hysp-pct]').forEach(function (el) { el.textContent = t.pct > 0 ? t.pct + '% OFF' : ''; });
  }
  paintPrices();
  if (hero && tiers.length > 1 && w.MutationObserver) {
    var mo = new MutationObserver(paintPrices);
    $all('.hbo-hero__info [data-tier]', hero).forEach(function (el) { mo.observe(el, { attributes: true, attributeFilter: ['aria-checked'] }); });
  }

  /* ---------- buttons: go = scroll to the buy box, buy = press the hero CTA (same cart as hyt-bp) */
  function heroCta() { return hero && hero.querySelector('[data-cta]'); }
  function goBuy() {
    var a = d.getElementById('hbo-buy');
    if (!a) return;
    var y = a.getBoundingClientRect().top + w.pageYOffset - barH() - 16;
    w.scrollTo({ top: Math.max(0, y), behavior: RM ? 'auto' : 'smooth' });
    var c = heroCta();
    if (c) { c.classList.remove('hysp-flash'); void c.offsetWidth; c.classList.add('hysp-flash'); setTimeout(function () { c.classList.remove('hysp-flash'); }, 2200); }
  }
  /* the hbo section buttons (hbo-sec-cta) buy like the hero CTA here, instead of scrolling back to the box */
  d.addEventListener('click', function (e) {
    var s = e.target.closest ? e.target.closest('.hbo-scta [data-scta]') : null;
    if (!s || !heroCta()) return;
    e.preventDefault(); e.stopPropagation();
    heroCta().click();
  }, true);
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-hysp-go],[data-hysp-buy]') : null;
    if (!t) return;
    e.preventDefault();
    /* credit the story button in hbo-hero's tap source (_hbo_src on the bundle line): its tracker only
       names hbo_* sections, so a real tap on a hysp_* chapter button writes its own id, same format */
    var SRC = w.__HBO_SRC, sec = t.closest('[id^="shopify-section-"]');
    if (e.isTrusted && SRC && sec) {
      var id = (sec.id.match(/__([^_].*)$/) || [0, 'hysp'])[1] + ':' + (t.hasAttribute('data-hysp-buy') ? 'buy' : 'go');
      SRC.fin = SRC.last = id; SRC.trail.push(id); if (SRC.trail.length > 5) SRC.trail.shift();
    }
    if (t.hasAttribute('data-hysp-buy') && heroCta()) heroCta().click(); else goBuy();
  });

  /* ---------- chapter reveal + lazy loop videos */
  function onIn(el, cb, opts) {
    if (!IO) { cb(el); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); cb(en.target); } });
    }, opts || { rootMargin: '0px 0px -18% 0px', threshold: 0.05 });
    io.observe(el);
  }
  $all('[data-hysp-ch]').forEach(function (ch) {
    onIn(ch, function () {
      ch.classList.add('is-in');
      $all('[data-count]', ch).forEach(countUp);
      if (ch.querySelector('[data-hysp-gut]')) gutAuto(ch.querySelector('[data-hysp-gut]'));
    });
  });
  function countUp(el) {
    var raw = el.getAttribute('data-count') || '', m = raw.match(/^(\D*)(\d+)(.*)$/);
    if (!m || RM) return;
    var end = +m[2], t0 = null, dur = 1100;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = m[1] + Math.round(end * e) + m[3];
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function wireVideo(v, box) {
    v.addEventListener('playing', function () { (box || v.parentNode).classList.add('is-play'); });
    if (!IO || RM) return;
    loopReg(v);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        v.__want = en.isIntersecting;
        if (en.isIntersecting) {
          if (!v.getAttribute('src') && v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); }
          playSafe(v);
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '240px 0px 240px 0px' });
    io.observe(box || v);
  }
  $all('video[data-hysp-vid]').forEach(function (v) { wireVideo(v, v.parentNode); });

  /* ---------- why: the gut toggles from "without" to "with" once it is seen, unless touched */
  function gutPlay(g) {
    var on = g.classList.contains('is-with') ? '1' : '0';
    $all('[data-gutv]', g).forEach(function (v) {
      if (g.__seen && !v.getAttribute('src')) { v.preload = 'auto'; v.src = v.getAttribute('data-src'); }
      v.__want = v.getAttribute('data-gutv') === on && !!g.__seen;
      if (v.__want) playSafe(v); else if (!v.paused) v.pause();
    });
  }
  function gutSet(g, on) {
    g.classList.toggle('is-with', !!on);
    if (g.__vids) gutPlay(g);
    $all('[data-gut]', g).forEach(function (b) { var me = b.getAttribute('data-gut') === (on ? '1' : '0'); b.classList.toggle('is-on', me); b.setAttribute('aria-pressed', me ? 'true' : 'false'); });
  }
  function gutAuto(g) {
    if (g.__auto) return; g.__auto = true;
    setTimeout(function () { if (!g.__touched) gutSet(g, true); }, RM ? 0 : 3200);
  }
  $all('[data-hysp-gut]').forEach(function (g) {
    g.__vids = !!g.querySelector('[data-gutv]');
    /* the stills are the only visual here, so they load a screen ahead instead of with the page */
    onIn(g, function () { $all('[data-gutv]', g).forEach(function (v) { if (v.getAttribute('data-poster')) v.poster = v.getAttribute('data-poster'); }); }, { rootMargin: '100% 0px 100% 0px' });
    if (g.__vids && IO && !RM) {
      $all('[data-gutv]', g).forEach(loopReg);
      new IntersectionObserver(function (es) { g.__seen = es[0].isIntersecting; gutPlay(g); }, { rootMargin: '200px 0px 200px 0px' }).observe(g);
    }
    $all('[data-gut]', g).forEach(function (b) {
      b.addEventListener('click', function () { g.__touched = true; gutSet(g, b.getAttribute('data-gut') === '1'); });
    });
  });

  /* ---------- chat: each bubble arrives as it scrolls in; More opens the rest */
  $all('[data-hysp-msg]').forEach(function (m) { onIn(m, function () { m.classList.add('is-in'); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 }); });
  $all('[data-hysp-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var root = b.closest('.hysp-chat');
      $all('.is-more', root).forEach(function (m) { m.classList.remove('is-more'); });
      b.parentNode.removeChild(b);
    });
  });

  /* ---------- weeks line fills with scroll */
  var lines = $all('[data-hysp-line]');
  if (lines.length && !RM) {
    var ticking = false;
    var fill = function () {
      ticking = false;
      var vh = w.innerHeight;
      lines.forEach(function (l) {
        var r = l.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (vh * 0.62 - r.top) / Math.max(1, r.height)));
        l.style.setProperty('--p', p.toFixed(3));
      });
    };
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(fill); } }, { passive: true });
    fill();
  }

  /* ---------- final: countdown to the visitor's local midnight, the same clock as the Halloween bar on top (hw-bar.liquid),
     so the two timers on the page always show the same time */
  var timers = $all('[data-hysp-timer]');
  if (timers.length) {
    var tick = function () {
      var now = new Date(), end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      var txt = [h, m, s].map(function (n) { return (n < 10 ? '0' : '') + n; }).join(':');
      timers.forEach(function (t) { t.textContent = txt; });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- sticker icons (stroke art, drawn here so they stay crisp at any size) */
  var ICO = (function () {
    var p = function (c, d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="' + c + '" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>'; };
    return {
      stomach: p('#e8402f', '<path d="M9 2.5v4c0 2-1.1 3.2-3 4.6C4 12.6 3.4 15.3 4.6 17.6c1.6 3 5.6 4 9.1 2.9 4-1.3 6.3-4.6 6.3-8.1 0-3-2-4.6-4.1-4.1-1.5.4-2 1.8-3.3 1.6-1.2-.2-.8-3.1-.8-7.4"/>'),
      gut: p('#00a6d6', '<path d="M12 2.5v2.5M7 5h10c1.9 0 1.9 3.2 0 3.2H7c-1.9 0-1.9 3.2 0 3.2h10c1.9 0 1.9 3.2 0 3.2H7c-1.9 0-1.9 3.2 0 3.2h5v2.2"/>'),
      leaf: p('#1f7a4c', '<path d="M4.5 19.5C4.5 10.8 10 4.5 19.5 4.5c0 9.4-6.3 15-15 15z"/><path d="M4.5 19.5l8.5-8.5"/>'),
      moon: p('#5b4bd6', '<path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/>'),
      sun: p('#e89a0c', '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4"/>'),
      clock: p('#0094c2', '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>'),
      star: p('#e89a0c', '<path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"/>'),
      capsule: p('#c2410c', '<rect x="3" y="8.5" width="18" height="7" rx="3.5" transform="rotate(-35 12 12)"/><path d="M9.6 8.6l4.8 6.8"/>'),
      shield: p('#16a05a', '<path d="M12 2.8l7.5 3v5.6c0 4.6-3.2 8.3-7.5 9.8-4.3-1.5-7.5-5.2-7.5-9.8V5.8z"/><path d="M8.5 12l2.4 2.4 4.6-4.7"/>'),
      gift: p('#d4332e', '<rect x="3.5" y="9" width="17" height="11.5" rx="1.5"/><path d="M3 9h18M12 9v11.5M12 9C10.5 5 6.5 5 7.5 7.5 8.2 9 12 9 12 9zM12 9c1.5-4 5.5-4 4.5-1.5C15.8 9 12 9 12 9z"/>')
    };
  })();
  function sticker(icon, title, sub, i) {
    var el = d.createElement('div');
    el.className = 'hysp-fly__b'; el.style.setProperty('--i', i); el.style.setProperty('--r', (i % 2 ? '1.5deg' : '-1.5deg'));
    el.innerHTML = '<span class="hysp-fly__ico">' + (ICO[icon] || ICO.leaf) + '</span><span class="hysp-fly__t"><b></b><small></small></span>';
    el.querySelector('b').textContent = title; el.querySelector('small').textContent = sub || '';
    return el;
  }

  /* ---------- hero lead slide: her 7pm loop over the first gallery image + the real bottles */
  (function () {
    if (!hero) return;
    var slide = hero.querySelector('.hbo-gal__slide');
    var img = slide && slide.querySelector('img');
    if (!slide || !img) return;
    slide.classList.add('hysp-lead');
    if (cfg.heroPack) {
      var p = d.createElement('img');
      p.className = 'hysp-lead__pack'; p.src = cfg.heroPack; p.alt = cfg.packAlt || ''; p.width = 600; p.height = 600; p.decoding = 'async';
      slide.appendChild(p);
    }
    /* flying benefit badges (the three claims from hyt-bp's lead image), land once the loop is up */
    if (cfg.badges && cfg.badges.length) {
      var fly = d.createElement('div');
      fly.className = 'hysp-fly'; fly.setAttribute('aria-hidden', 'true');
      cfg.badges.forEach(function (bd, i) { fly.appendChild(sticker(bd[0], bd[1], bd[2], i)); });
      slide.appendChild(fly);
      /* all three on screen: they fly in one after another from the left, then float */
      setTimeout(function () { slide.classList.add('is-fly'); }, RM ? 0 : 600);
    }
    if (cfg.heroDis) {
      var cap = d.createElement('span'); cap.className = 'hysp-lead__dis'; cap.textContent = cfg.heroDis; slide.appendChild(cap);
    }
    if (!cfg.heroVideo || RM) return;
    var v = w.__HYSP_HV || d.createElement('video');
    v.className = 'hysp-lead__v';
    v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto'; v.poster = img.currentSrc || img.src;
    img.parentNode.insertBefore(v, img.nextSibling);
    v.addEventListener('playing', function () { slide.classList.add('is-play'); });
    if (!v.getAttribute('src')) v.src = cfg.heroVideo;
    loopReg(v);
    if (IO) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { v.__want = en.isIntersecting && en.intersectionRatio > 0.4; if (v.__want) playSafe(v); else if (!v.paused) v.pause(); });
      }, { threshold: [0, 0.4, 1] }).observe(slide);
    } else { v.__want = true; playSafe(v); }
  })();

  /* ---------- benefit stickers on the other gallery slides: two per slide, replay each time it is swiped in */
  (function () {
    if (!hero || !cfg.galBadges || !cfg.galBadges.length) return;
    var slides = $all('.hbo-gal__slide', hero), vp = hero.querySelector('[data-vp]');
    var by = {};
    cfg.galBadges.forEach(function (g) { (by[g[0]] = by[g[0]] || []).push(g); });
    Object.keys(by).forEach(function (n) {
      var sl = slides[+n - 1];
      if (!sl) return;
      sl.style.position = 'relative';
      var box = d.createElement('div');
      box.className = 'hysp-gb'; box.setAttribute('aria-hidden', 'true');
      by[n].slice(0, 2).forEach(function (g, i) { box.appendChild(sticker(g[1], g[2], g[3], i)); });
      sl.appendChild(box);
      if (!IO || RM) { box.classList.add('is-in'); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { box.classList.toggle('is-in', en.intersectionRatio > 0.6); });
      }, { root: vp || null, threshold: [0, 0.6, 1] }).observe(sl);
    });
  })();

  /* ---------- loop videos on the other gallery slides: load + play only while the slide is showing */
  (function () {
    if (!hero || !cfg.galVideos || !cfg.galVideos.length || RM || !IO) return;
    var slides = $all('.hbo-gal__slide', hero), vp = hero.querySelector('[data-vp]');
    cfg.galVideos.forEach(function (g) {
      var sl = slides[g[0] - 1], img = sl && sl.querySelector('img');
      if (!sl || !img || !g[1]) return;
      sl.style.position = 'relative'; sl.style.overflow = 'hidden';
      var v = d.createElement('video');
      v.className = 'hysp-gv'; v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      v.preload = 'none'; v.poster = img.currentSrc || img.src;
      img.parentNode.insertBefore(v, img.nextSibling);
      v.addEventListener('playing', function () { v.classList.add('is-play'); });
      loopReg(v);
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          v.__want = en.intersectionRatio > 0.3;
          if (v.__want) { if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = g[1]; } playSafe(v); }
          else if (!v.paused) v.pause();
        });
      }, { root: vp || null, threshold: [0, 0.3, 1] }).observe(sl);
    });
  })();

  /* ---------- story tags on the reused hbo sections */
  var TAGS = {};
  (cfg.tags || []).forEach(function (t) {
    TAGS[t[0]] = t;
    var sec = d.querySelector('[id^="shopify-section-"][id$="__' + t[0] + '"]');
    if (!sec) return;
    sec.setAttribute('data-clock', t[1]); sec.setAttribute('data-clock-h', t[2] || '');
    var h = sec.querySelector('.hbo-h2, .hbo-h');
    if (h && t[3]) {
      var tag = d.createElement('p');
      tag.className = 'hysp hysp-tag';
      tag.innerHTML = '<span class="hysp-tag__t"></span><span class="hysp-tag__e"></span>';
      tag.firstChild.textContent = t[1]; tag.lastChild.textContent = t[3];
      h.parentNode.insertBefore(tag, h);
    }
  });

  /* ---------- section links: a dashed gold story thread through a lamp-lit scene card between sections.
     The card's mini clock spins to the next section's story time; the bar shows how far into the story we are. */
  (function () {
    if (!cfg.links || !cfg.links.length) return;
    var total = cfg.links.length;
    cfg.links.forEach(function (l, i) {
      var sec = d.querySelector('[id^="shopify-section-"][id$="__' + l[0] + '"]');
      if (!sec || !sec.parentNode) return;
      var tgt = sec.hasAttribute('data-clock') ? sec : sec.querySelector('[data-clock]');
      var label = tgt ? tgt.getAttribute('data-clock') : '', hm = (tgt ? tgt.getAttribute('data-clock-h') || '' : '').split(':');
      var H = +hm[0] || 0, M = +hm[1] || 0;
      var el = d.createElement('div');
      el.className = 'hysp hysp-link'; el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<svg class="hysp-link__thread" viewBox="0 0 48 112" preserveAspectRatio="none"><path d="M24 0C42 22 6 34 24 56S42 90 24 112"/></svg>' +
        '<div class="hysp-link__card"><i class="hysp-link__bead hysp-link__bead--t"></i>' +
        '<span class="hysp-link__clock"><svg viewBox="0 0 40 40"><circle class="hysp-link__face" cx="20" cy="20" r="16.5"/>' +
        '<path class="hysp-link__ticks" d="M20 5.8v3M20 31.2v3M5.8 20h3M31.2 20h3"/>' +
        '<line class="hysp-link__h" x1="20" y1="20" x2="20" y2="12.5"/><line class="hysp-link__m" x1="20" y1="20" x2="20" y2="8.5"/><circle class="hysp-link__pin" cx="20" cy="20" r="2.2"/></svg></span>' +
        '<span class="hysp-link__txt"><span class="hysp-link__kick"></span><span class="hysp-link__cap"></span><span class="hysp-link__bar"><i></i></span></span>' +
        '<i class="hysp-link__bead hysp-link__bead--b"></i></div>';
      var card = el.querySelector('.hysp-link__card');
      card.style.setProperty('--hd', ((H % 12) * 30 + M * 0.5 + 360) + 'deg');
      card.style.setProperty('--md', (M * 6 + 720) + 'deg');
      card.style.setProperty('--p', Math.round((i + 1) / total * 100) + '%');
      el.querySelector('.hysp-link__kick').textContent = 'Scene ' + (i + 1 < 10 ? '0' : '') + (i + 1) + (label ? '  ·  ' + label : '');
      el.querySelector('.hysp-link__cap').textContent = l[1];
      sec.parentNode.insertBefore(el, sec);
      onIn(el, function () { el.classList.add('is-in'); }, { rootMargin: '0px 0px -12% 0px', threshold: 0.4 });
    });
  })();

  /* ---------- the story clock: follows whichever chapter crosses the middle of the screen */
  var clock = d.querySelector('[data-hysp-clock]');
  if (clock && IO) {
    var lbl = clock.querySelector('[data-hysp-clock-l]'), hh = clock.querySelector('.hysp-clock__h'), mm = clock.querySelector('.hysp-clock__m');
    var beats = $all('[data-clock]').filter(function (el) { return el.getAttribute('data-clock'); });
    var curIdx = -1, total = 0, prevMin = null;
    var setClock = function (idx) {
      if (idx === curIdx) return;
      var el = beats[idx], label = el.getAttribute('data-clock'), hm = (el.getAttribute('data-clock-h') || '').split(':');
      var mins = (+hm[0] || 0) * 60 + (+hm[1] || 0);
      if (prevMin === null) total = mins;
      else {
        var fwd = ((mins - prevMin) % 1440 + 1440) % 1440;
        total += idx > curIdx ? (fwd || 1440) : -(((prevMin - mins) % 1440 + 1440) % 1440 || 1440);
      }
      prevMin = mins; curIdx = idx;
      lbl.textContent = label;
      mm.style.transform = 'rotate(' + (total * 6) + 'deg)';
      hh.style.transform = 'rotate(' + (total * 0.5) + 'deg)';
      clock.classList.remove('is-tick'); void clock.offsetWidth; clock.classList.add('is-tick');
    };
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) setClock(beats.indexOf(en.target)); });
    }, { rootMargin: '-48% 0px -48% 0px' });
    beats.forEach(function (b) { io2.observe(b); });
    /* shown between the hero and the legal band */
    var heroOut = false, endIn = false, legal = d.querySelector('.hbo-legal');
    var vis = function () { clock.classList.toggle('is-on', heroOut && !endIn); clock.style.top = (barH() + 10) + 'px'; };
    if (hero) new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; vis(); }).observe(hero);
    if (legal) new IntersectionObserver(function (es) { endIn = es[0].isIntersecting; vis(); }).observe(legal);
    w.addEventListener('scroll', function () { if (clock.classList.contains('is-on')) clock.style.top = (barH() + 10) + 'px'; }, { passive: true });
  }

  /* ---------- checkout story tag: the bundle line from this page carries _pc_story (Checkout Blocks rules swap in the
     toon offer card, terms timer and thank-you finale on it). hbo-hero's buy() is untouched; its add.js body is tagged here */
  if (w.fetch && cfg.story) {
    var ofTag = w.fetch;
    w.fetch = function (u, o) {
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && o && typeof o.body === 'string' && o.body.indexOf('_hbo_src') > -1) {
          var b = JSON.parse(o.body);
          (b.items || []).forEach(function (it) { if (it.properties && it.properties._hbo_src) it.properties._pc_story = cfg.story; });
          return ofTag.call(this, u, Object.assign({}, o, { body: JSON.stringify(b) }));
        }
      } catch (e) {}
      return ofTag.apply(this, arguments);
    };
  }

  /* ---------- checkout beat: shows when hbo-hero starts its cart call right after a buy tap */
  var beat = d.querySelector('[data-hysp-beat]');
  if (beat && w.fetch) {
    var lastTap = 0, beatOn = false, timers2 = [], warmed = false;
    var bv = beat.querySelector('video');
    /* the gift shelf: the buy box's own 5 gift images, as round stickers that fly in while the beat runs */
    var shelf = beat.querySelector('[data-hysp-gifts]');
    if (shelf && hero) {
      $all('.hbo-gifts .hbo-gift', hero).slice(0, 6).forEach(function (g, i) {
        var im = g.querySelector('img'); if (!im) return;
        var el = d.createElement('span');
        el.className = 'hysp-beat__gift'; el.style.setProperty('--i', i);
        el.innerHTML = '<img alt="" width="80" height="80"><b>FREE</b>';
        el.querySelector('img').src = im.currentSrc || im.src;
        shelf.appendChild(el);
      });
    }
    var warm = function () {
      if (warmed || !bv || RM) return; warmed = true;
      bv.preload = 'auto'; bv.src = bv.getAttribute('data-src');
    };
    d.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-cta],[data-leadtag],[data-hysp-buy],[data-scta],.hbo-stk button,.hbo-stk a,.hbo-sticky button,.hbo-sticky a') : null;
      if (t) { lastTap = Date.now(); warm(); }
    }, true);
    /* warm the loop once the shopper is deep enough to be deciding */
    w.addEventListener('scroll', function () { if (!warmed && w.pageYOffset > d.body.scrollHeight * 0.45) warm(); }, { passive: true });
    var hide = function () {
      if (!beatOn) return; beatOn = false;
      timers2.forEach(clearTimeout); timers2 = [];
      beat.classList.remove('is-on');
      de.classList.remove('hysp-beat-on');
      setTimeout(function () { if (!beatOn) { beat.hidden = true; $all('li', beat).forEach(function (li) { li.classList.remove('is-done'); }); if (bv) bv.pause(); } }, 320);
    };
    var show = function () {
      if (beatOn) return; beatOn = true;
      beat.hidden = false;
      de.classList.add('hysp-beat-on');
      requestAnimationFrame(function () { beat.classList.add('is-on'); });
      if (bv) { warm(); playSafe(bv); bv.addEventListener('playing', function () { beat.classList.add('is-play'); }, { once: true }); }
      [280, 1180, 1750].forEach(function (ms, i) { var li = $all('li', beat)[i]; if (li) timers2.push(setTimeout(function () { li.classList.add('is-done'); }, ms)); });
      timers2.push(setTimeout(hide, 15000));
    };
    var of = w.fetch;
    w.fetch = function (u) {
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/(add|clear)(\.js)?(\?|$)/.test(url) && Date.now() - lastTap < 2500) show();
      } catch (e) {}
      return of.apply(this, arguments);
    };
    var err = hero && hero.querySelector('[data-err]');
    if (err && w.MutationObserver) new MutationObserver(function () { if (err.classList.contains('is-on')) hide(); }).observe(err, { attributes: true, attributeFilter: ['class'] });
    w.addEventListener('pageshow', function (e) { if (e.persisted) hide(); });
  }
})();
